
<template>

  <div class="marketplaceFooter" >
    <div class="container">

      <div class="marketplaceFooter_main" >

        <div class="marketplaceFooter_main_section" >
          <div class="marketplaceFooter_logomark">
            <pickstar-logomark />
          </div>
        </div>

        <div class="marketplaceFooter_main_section" v-if="menus.general_links && menus.general_links.length" >
          <h3 class="marketplaceFooter_heading" >Pickstar</h3>
          <ul class="marketplaceFooter_generalNav" >
            <li v-for="(item, index) in menus.general_links" :key="index" >
              <a :href="item.link">{{ item.label }}</a>
            </li>
          </ul>
        </div>

        <div class="marketplaceFooter_main_section" v-if="regionInfo" >
          <h3 class="marketplaceFooter_heading" >{{ regionInfo.name }}</h3>
          <div class="marketplaceFooter_office">
            <div v-if="regionInfo.address" v-html="$options.filters.nl2br(regionInfo.address)" ></div>
            <div class="marketplaceFooter_contactItem" v-if="regionInfo.phone" >
              <a :href="`tel:${ regionInfo.phone }`" ><i class="fa fa-phone"></i> {{ regionInfo.phone }}</a>
            </div>
            <div class="marketplaceFooter_contactItem" v-if="regionInfo.from_email" >
              <a :href="`mailto:${ regionInfo.from_email }`"><i class="fa fa-at"></i> {{ regionInfo.from_email }}</a>
            </div>
          </div>
        </div>

        <div class="marketplaceFooter_main_section" v-if="menus.social_links && menus.social_links.length" >
          <ul class="marketplaceFooter_socials" >
            <li v-for="(item, index) in menus.social_links" :key="index" >
              <a class="marketplaceFooter_socials_link" :href="item.link" target="_blank" :aria-label="item.label" >
                <i :class="`fa fa-${ item.name }`"></i>
              </a>
            </li>
          </ul>
        </div>

      </div>

      <div class="marketplaceFooter_additional" >

        <div class="marketplaceFooter_copyright">
          <span>&copy; Copyright {{ year }} PickStar</span>
          <span v-if="regionInfo && regionInfo.company_reg" >{{ regionInfo.company_reg }}</span>
        </div>

        <ul class="marketplaceFooter_legals" v-if="menus.legal_links && menus.legal_links.length" >
          <li v-for="(item, index) in menus.legal_links" :key="index" >
            <a :href="item.link">{{ item.label }}</a>
          </li>
        </ul>

      </div>

    </div>
  </div>

</template>

<script>

import PickstarLogomark from '../icons/PickstarLogomark'
import {mapActions, mapState} from 'vuex'
import nl2br from '../../filters/nl2br'

export default {

  components: {
    PickstarLogomark
  },

  filters: {
    nl2br
  },

  computed: {
    ...mapState('region', ['regions']),

    year () {
      const date = new Date()
      return date.getFullYear()
    },

    regionInfo () {
      if (!this.$user || !this.$user.region_id || !this.regions || !this.regions.length) { return null }

      return this.regions.find(region => region.id === this.$user.region_id)
    },

    menus () {
      return this.regionInfo && this.regionInfo.json_urls ? JSON.parse(this.regionInfo.json_urls) : {}
    }
  },

  mounted () {
    this.getRegions()
  },

  methods: {
    ...mapActions('region', ['getRegions'])
  }

}
</script>
